import React from 'react'
import { ReactComponent as LogoIcon } from './icons/logo.svg'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '@styles/vars'

export default function Logo({ to, fill }: Props) {
    const logo = <Wrapper fill={fill}><LogoIcon /></Wrapper>
    return to ? <Link to={to}>{logo}</Link> : logo
}

// STYLES
const Wrapper = styled.div<{ fill?: string }>`
    height: 60px;
    width: 60px;
    flex-shrink: 0;
    max-width: 100%;
    max-height: 100%;

    svg {
        fill: ${props => props.fill || colors.black};
        width: 100%;
        height: 100%;
    }
`

// TYPES
interface Props {
    to?: string
    fill?: string
}